/**
 * @description
 * Objeto Comments
 */

export class CommentsInterna {
    public id:number = null;
    public login: string;
    public dboid: string;
    public text: string;
    public nif: string;
    public created_at: Date;
    public upcated_at: Date;
  
    constructor() {}
}